import { render } from "./App.vue?vue&type=template&id=06c40c57"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon-sg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__